import { render, staticRenderFns } from "./caseRisk.vue?vue&type=template&id=7af65adc&scoped=true"
import script from "./caseRisk.vue?vue&type=script&lang=js"
export * from "./caseRisk.vue?vue&type=script&lang=js"
import style0 from "./caseRisk.vue?vue&type=style&index=0&id=7af65adc&prod&scoped=true&lang=less"
import style1 from "./caseRisk.vue?vue&type=style&index=1&id=7af65adc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af65adc",
  null
  
)

export default component.exports